{
  "tutorial_page": {
    "title": "Get started",
    "description": "Experience SparkLayer exactly as a B2B buyer would.",
    "footer": "Learn more about testing as a B2B customer",
    "explore_hint": "You're free to explore the rest of the app anytime. These steps will be here when you're ready.",
    "get_help": "Get help",
    "complete": "Complete",
    "progress_start": "Let's get started!",
    "progress_mid": "You're making progress!",
    "progress_done": "You're all set!",
    "skip": "Skip",
    "skip_confirm": {
      "title": "Skip setup?",
      "body": "You can pick these steps back up anytime from the dashboard.",
      "confirm": "Skip setup"
    }
  },
  "setup_page": {
    "title": "Get live with SparkLayer",
    "description": "Work through these steps to start selling B2B.",
    "footer": "Learn more about setting up SparkLayer",
    "complete": "Try it out",
    "progress_start": "Let's get your store ready",
    "progress_mid": "You're making progress!",
    "progress_done": "You're all set!"
  }
}
